import { h, Component } from "preact";
import style from "./style";
import * as solver from "../../solver";
import Solution from "../solution";

export default class Home extends Component {
  state = {
    rows: 7,
    columns: 7,
    grid: []
  };
  disabled = false;
  puzzleSolved = false;
  puzzleNotSolved = false;
  puzzle;
  constructor() {
    super();
    this.puzzle = this.createEmptyPuzzle(this.state.rows, this.state.columns);
    let grid = this.createGrid(
      this.state.rows,
      this.state.columns,
      this.puzzle
    );
    this.setState({ grid });
  }

  createGrid(rows, columns, puzzle) {
    let fontStyle = this.getFontSize(columns);
    return puzzle.map((row, ri) => {
      return (
        <div>
          {row.map((c, ci) => {
            return (
              <input
                value={c}
                type="text"
                disabled={this.disabled}
                onChange={this.changeBox.bind(this, [ri, ci])}
                key={[ri, ci]}
                aria-label={"box " + (ri + 1) + " " + (ci + 1)}
                class={style.grid__box}
                style={fontStyle}
              />
            );
          })}
        </div>
      );
    });
  }

  changeBox = (key, event) => {
    let value = Number(event.target.value);
    if (value > 8 || value < 1 || isNaN(value)) {
      value = "";
    }
    this.puzzle[key[0]][key[1]] = value;
    let grid = this.createGrid(
      this.state.rows,
      this.state.columns,
      this.puzzle
    );
    this.setState({ grid });
  };

  createEmptyPuzzle(rows, columns) {
    return new Array(rows).fill(0).map((r, ri) => {
      return new Array(columns).fill("");
    });
  }

  changeRows = e => {
    let rows = Number(e.target.value);
    this.puzzle = this.createEmptyPuzzle(rows, this.state.columns);
    let grid = this.createGrid(rows, this.state.columns, this.puzzle);
    this.setState({ rows, grid });
  };

  changeColumns = e => {
    let columns = Number(e.target.value);
    this.puzzle = this.createEmptyPuzzle(this.state.rows, columns);
    let grid = this.createGrid(this.state.rows, columns, this.puzzle);
    this.setState({ columns, grid });
  };

  solvePuzzle = () => {
    let result = solver(this.puzzle);
    this.disabled = true;
    if (result[0] === true) {
      let puzzle = result[1];
      for (let i = 0; i < puzzle.length; i++) {
        for (let j = 0; j < puzzle[i].length; j++) {
          this.puzzle[i][j] = puzzle[i][j];
        }
      }
      this.puzzleSolved = true;
      let grid = this.createGrid(
        this.state.rows,
        this.state.columns,
        this.puzzle
      );
      this.setState({ grid });
    } else {
      this.puzzleNotSolved = true;
      let grid = this.createGrid(
        this.state.rows,
        this.state.columns,
        this.puzzle
      );
      this.setState({ grid });
    }
  };

  resetPuzzle = () => {
    this.puzzle = this.createEmptyPuzzle(this.state.rows, this.state.columns);
    this.disabled = false;
    this.puzzleSolved = false;
    this.puzzleNotSolved = false;
    let grid = this.createGrid(
      this.state.rows,
      this.state.columns,
      this.puzzle
    );
    this.setState({ grid });
  };

  getFontSize = columns => {
    let size = 60 / columns;
    return { fontSize: size + "vw" };
  };

  render({}, { rows, columns, grid }) {
    let notification = "";
    if (this.puzzleSolved === true) {
      notification = <p class={style.notification}>PUZZLE SOLVED!</p>;
    } else if (this.puzzleNotSolved === true) {
      notification = <p class={style.notification}>FAILED SOLVING PUZZLE!</p>;
    }

    let solution = "";
    if (this.puzzleSolved || this.puzzleNotSolved) {
      solution = <Solution columns={columns} puzzle={this.puzzle} />;
    } else {
      solution = grid;
    }

    return (
      <div class={style.home}>
        <p>Place the islands and press "Solve" to solve the bridges puzzle.</p>
        <div class={style.chooser}>
          <label>
            Rows
            <input
              type="number"
              value={rows}
              onChange={this.changeRows}
              class={style.chooser__input}
            />
          </label>
          <label>
            Columns
            <input
              type="number"
              value={columns}
              onChange={this.changeColumns}
              class={style.chooser__input}
            />
          </label>
        </div>
        {notification}
        <div
          class={
            style.grid +
            " " +
            (this.puzzleSolved ? style.solved : "") +
            " " +
            (this.puzzleNotSolved ? style.notSolved : "")
          }
        >
          {/* {grid} */}
          {solution}
        </div>
        <div>
          <button
            onClick={this.solvePuzzle}
            class={style.button}
            disabled={this.disabled}
          >
            Solve
          </button>
          <button onClick={this.resetPuzzle} class={style.button}>
            Reset
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/home/index.js